export enum UserTokenTypeEnum {
  EMAILVERIFICATION = 'emailverification',
  RESETPASSWORD = 'resetpassword',
  GUEST_SET_PASSWORD = 'GUEST_SET_PASSWORD'
}
